import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "lg:container lg:mx-auto pt-10 md:pt-12" }
const _hoisted_2 = { class: "px-4 lg:px-0" }
const _hoisted_3 = {
  key: 0,
  class: "px-4 lg:px-0"
}
const _hoisted_4 = { class: "text-black-600" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mb-16" }, null, -1)
const _hoisted_6 = { class: "px-4 lg:px-0" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "flex flex-col md:flex-row w-full justify-between items-end lg:items-center" }
const _hoisted_9 = {
  key: 1,
  class: "px-4 lg:px-0"
}
const _hoisted_10 = { class: "text-black-600" }
const _hoisted_11 = {
  key: 2,
  class: "mt-16 p-4 lg:p-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalStack = _resolveComponent("BalStack")!
  const _component_PoolsTable = _resolveComponent("PoolsTable")!
  const _component_BalLink = _resolveComponent("BalLink")!
  const _component_TokenSearchInput = _resolveComponent("TokenSearchInput")!
  const _component_FeaturedPools = _resolveComponent("FeaturedPools")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isWalletReady)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_BalStack, {
              horizontal: "",
              justify: "between",
              align: "center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.$t('myV2Investments')), 1),
                _createVNode(_component_BalBtn, {
                  onClick: _ctx.navigateToCreatePool,
                  color: "blue",
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('createAPool.title')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_PoolsTable, {
            isLoading: _ctx.isLoadingUserPools,
            data: _ctx.userPools,
            noPoolsLabel: _ctx.$t('noInvestments'),
            showPoolShares: "",
            showMigrationColumn: _ctx.showMigrationColumn,
            selectedTokens: _ctx.selectedTokens,
            class: "mb-8",
            key: 
          `userPoolsTable-${
            _ctx.showMigrationColumn ? 'withMigrationCol' : 'withoutMigrationCol'
          }`
        
          }, null, 8, ["isLoading", "data", "noPoolsLabel", "showMigrationColumn", "selectedTokens"]),
          (!_ctx.hideV1Links)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('seeV1BalancerInvestments')), 1),
                _createVNode(_component_BalLink, {
                  href: _ctx.EXTERNAL_LINKS.Balancer.PoolsV1Dashboard,
                  external: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('goToBalancerV1Site')), 1)
                  ]),
                  _: 1
                }, 8, ["href"])
              ]))
            : _createCommentVNode("", true),
          _hoisted_5
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t('investmentPools')), 1),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_TokenSearchInput, {
          modelValue: _ctx.selectedTokens,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedTokens = $event)),
          loading: _ctx.isLoadingPools,
          onAdd: _ctx.addSelectedToken,
          onRemove: _ctx.removeSelectedToken,
          class: "w-full md:w-2/3"
        }, null, 8, ["modelValue", "loading", "onAdd", "onRemove"]),
        _createVNode(_component_BalBtn, {
          onClick: _ctx.navigateToCreatePool,
          color: "blue",
          size: "sm",
          class: _normalizeClass({ 'mt-4': _ctx.upToMediumBreakpoint }),
          block: _ctx.upToMediumBreakpoint
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('createAPool.title')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "class", "block"])
      ])
    ]),
    _createVNode(_component_PoolsTable, {
      isLoading: _ctx.isLoadingPools,
      data: _ctx.filteredPools,
      noPoolsLabel: _ctx.$t('noPoolsFound'),
      isPaginated: _ctx.poolsHasNextPage,
      isLoadingMore: _ctx.poolsIsFetchingNextPage,
      onLoadMore: _ctx.loadMorePools,
      selectedTokens: _ctx.selectedTokens,
      class: "mb-8"
    }, null, 8, ["isLoading", "data", "noPoolsLabel", "isPaginated", "isLoadingMore", "onLoadMore", "selectedTokens"]),
    (!_ctx.hideV1Links)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('tableShowsBalancerV2Pools')), 1),
          _createVNode(_component_BalLink, {
            href: _ctx.EXTERNAL_LINKS.Balancer.PoolsV1Explore,
            external: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('exploreBalancerV1Pools')), 1)
            ]),
            _: 1
          }, 8, ["href"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isElementSupported)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_FeaturedPools)
        ]))
      : _createCommentVNode("", true)
  ]))
}